export default {
  knowledgeLib_move: 'Transfer',
  knowledgeLib_copy: 'Copy',
  knowledgeLib_del: 'Delete',
  knowledgeLib_download: 'Download',
  knowledgeLib_upload: 'Upload',
  knowledgeLib_enter_keywords: 'Please enter a keyword',
  knowledgeLib_enter_lib_name: "Please enter library's name to query",
  knowledgeLib_also_learning: 'They are learning',
  knowledgeLib_file_uploading: 'Library uploading, please try again later',
  knowledgeLib_select_lib: 'Please select library!' ,
  knowledgeLib_upload_file: 'Please upload file!' ,
  knowledgeLib_select_lib_folder: 'Please select library or folder!' ,
  knowledgeLib_select_path: 'Please select path:',
  knowledgeLib_support_extensions: 'Supported extensions: .doc .docx .pdf .xlsx .xls .ppt .pptx .png .jpeg .jpg .bmp .msg .mht format',
  knowledgeLib_just_now: 'Just now',
  knowledgeLib_minutes_ago: '{dm, plural, =0 {no minutes} =1 {one minute} other {# minutes}} ago',
  knowledgeLib_hour_ago: '{dm, plural, =0 {no hours} =1 {one hour} other {# hours}} ago',
  knowledgeLib_ten_thousand: '{n} thousand',
  knowledgeLib_browse_num: '{browseNum, plural, =0 {no people has} =1 {one people has} other {# people have}} browsed',
  knowledgeLib_no_intro: 'No introduction',
  knowledgeLib_library: 'Liabrary',
  knowledgeLib_create_user: 'Create user',
  knowledgeLib_update_time: 'Update time',
  knowledgeLib_folder: 'Folder',
  knowledgeLib_fail_upload: 'Failed to upload. Please delete and re-upload',
  knowledgeLib_uploading: 'Uploading',
  knowledgeLib_select_folder: 'Please select file or folder!',
  knowledgeLib_success_tip: 'Succeeded',
  knowledgeLib_del_success: 'Delete successfully',
  knowledgeLib_enter_files_name: 'Enter file name',
  knowledgeLib_back_previous: 'Return to previous level',
  knowledgeLib_confirm_del: 'Delete these files?',
  knowledgeLib_select_library: 'Please select library',
  knowledgeLib_choice_library: 'Please select library:',
  knowledgeLib_total_library: 'All libraries',
  knowledgeLib_total_number: 'Total: {totalFileNum}',
  knowledgeLib_no_access: 'No access permission or no data',
  knowledgeLib_enter_library_name: 'Enter library name',
  knowledgeLib_no_library: "No library",
  knowledgeLib_classify: 'Category',
  knowledgeLib_select_classify: 'View by Categories',
  knowledgeLib_hot_files: 'Most Popular Uploads',
  knowledgeLib_empty_files: 'No files',
  knowledgeLib_upload_user: 'Operator',
  knowledgeLib_files_num: '{totalFileNum, plural, =0 {no files} =1 {one file} other {# files}}',
  knowledgeLib_last_upload: 'Lastest',
  knowledgeLib_upload_time: 'Upload Time',
  knowledgeLib_total_files: 'All files',
  knowledgeLib_select: 'Please select file or folder!',
  knowledgeLib_selected_all: 'Used / Total: '
}
